export const AlternateOptionMap: Record<number, string> = Object.freeze({
  2: 'Every 2nd day',
  3: 'Every 3rd day',
  4: 'Every 4th day',
});
